/**
 * Drop gate: toggles between the "in arrivo" block and the purchase blocks
 * on a product page (and the "in arrivo" badge on product cards), based on
 * custom.drop_date and the early-access cookie. Ricorda anche (per browser)
 * per quali form "avvisami" è già stata inviata l'iscrizione, cosi' il
 * campo email non ricompare.
 * Runs entirely client-side (see snippets/drop-gate-arrivo.liquid for why).
 *
 * Il form "avvisami" si invia in modo nativo (niente fetch/preventDefault):
 * hCaptcha, obbligatorio su tutti i form customer/contact di Shopify, si
 * aggancia all'evento submit reale della pagina (vedi commento su
 * bindNotifyForm più sotto) — un invio via fetch bypassa quell'aggancio e
 * Shopify rifiuta la richiesta lato server, ma con mode:'no-cors' quel
 * rifiuto è invisibile a JS: il form sembrava funzionare e non salvava
 * nessuna iscrizione. Scoperto in produzione, non solo in teoria.
 */
(function () {
  'use strict';

  // Il tag <script> viene incluso una volta per ogni card_product con
  // drop_gate_enabled (snippets/card-product.liquid): su una pagina
  // collezione con più prodotti "in arrivo" lo stesso script comparirebbe
  // più volte e si eseguirebbe più volte. Le funzioni sotto sono già
  // idempotenti, ma l'observer aggiunto in fondo va creato una sola volta.
  if (window.__dropGateInit) return;
  window.__dropGateInit = true;

  var COOKIE_PREFIX = 'ea_';
  var COOKIE_MAX_AGE_DAYS = 7;
  var NOTIFIED_STORAGE_KEY = 'dropGateNotifiedProducts';

  function getCookie(name) {
    var target = name + '=';
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (part.indexOf(target) === 0) {
        return decodeURIComponent(part.slice(target.length));
      }
    }
    return null;
  }

  function setCookie(name, value, days) {
    var maxAge = days * 24 * 60 * 60;
    document.cookie = name + '=' + encodeURIComponent(value) + '; max-age=' + maxAge + '; path=/; SameSite=Lax';
  }

  // Se l'URL contiene ?ea=<token>, sblocca (via cookie) tutti i prodotti con
  // quello stesso drop_token, non solo quello aperto dal link diretto. Canale
  // manuale, tenuto come alternativa (es. link condiviso fuori da Shopify
  // Email), ma non è il meccanismo principale: vedi sotto.
  function unlockToken(token) {
    if (!token) return;
    setCookie(COOKIE_PREFIX + token, '1', COOKIE_MAX_AGE_DAYS);
  }

  // Meccanismo principale di accesso anticipato: la newsletter di annuncio
  // drop inserisce i prodotti tramite il blocco "Prodotto" nativo di Shopify
  // Email, che non permette di aggiungere parametri custom come ?ea=. Shopify
  // però aggiunge da solo, senza bisogno di alcuna configurazione,
  // utm_source=shopify_email a ogni link della campagna (verificato su un
  // invio di prova reale) — anche a quelli generati dal blocco prodotto.
  // Usiamo quel segnale: chi arriva su una pagina prodotto da lì sblocca il
  // drop_token del prodotto stesso (letto dal blocco "in arrivo" già presente
  // in pagina, non serve che sia nell'URL), quindi l'intero drop della
  // settimana tramite lo stesso meccanismo di cookie condiviso. Nessuna
  // configurazione richiesta lato Shopify Email, funziona automaticamente
  // ogni settimana con il flusso reale già in uso.
  function applyEarlyAccessFromUrl() {
    var params = new URLSearchParams(window.location.search);

    unlockToken(params.get('ea'));

    var utmSource = params.get('utm_source');
    if (utmSource && utmSource.toLowerCase() === 'shopify_email') {
      var arrivoEl = document.querySelector('[data-drop-gate-arrivo]');
      var pageToken = arrivoEl ? arrivoEl.getAttribute('data-drop-gate-token') : null;
      unlockToken(pageToken);
    }
  }

  function isUnlockedByCookie(token) {
    if (!token) return false;
    return getCookie(COOKIE_PREFIX + token) === '1';
  }

  function isReleased(dateRaw) {
    var date = dateRaw ? new Date(dateRaw) : null;
    var hasValidDate = date instanceof Date && !isNaN(date.getTime());
    return !hasValidDate || Date.now() >= date.getTime();
  }

  // Ricorda (in questo browser) per quali prodotti è già stata inviata
  // l'iscrizione "avvisami al rilascio", cosi' il form non ricompare più per
  // lo stesso prodotto dopo un refresh o una visita successiva. localStorage
  // e non un cookie: non serve che il server lo legga, è solo uno stato
  // dell'interfaccia, quindi non ha senso spedirlo a ogni richiesta.
  function getNotifiedProducts() {
    try {
      var raw = window.localStorage.getItem(NOTIFIED_STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function isProductNotified(productId) {
    if (!productId) return false;
    return getNotifiedProducts().indexOf(productId) !== -1;
  }

  function markProductNotified(productId) {
    if (!productId) return;
    try {
      var products = getNotifiedProducts();
      if (products.indexOf(productId) === -1) {
        products.push(productId);
        window.localStorage.setItem(NOTIFIED_STORAGE_KEY, JSON.stringify(products));
      }
    } catch (e) {
      // localStorage non disponibile (es. modalità privata): l'iscrizione
      // avviene comunque, semplicemente non viene ricordata tra le sessioni.
    }
  }

  // Pagina prodotto: blocco "in arrivo" + blocchi prezzo/varianti/carrello.
  function evaluateGate(arrivoEl) {
    var container = arrivoEl.closest('product-info') || arrivoEl.parentElement;
    var buyBlocks = container ? container.querySelectorAll('[data-drop-gate-buy]') : [];

    var released = isReleased(arrivoEl.getAttribute('data-drop-gate-date'));
    var unlocked = released || isUnlockedByCookie(arrivoEl.getAttribute('data-drop-gate-token'));

    arrivoEl.hidden = unlocked;
    for (var i = 0; i < buyBlocks.length; i++) {
      buyBlocks[i].hidden = !unlocked;
    }
  }

  // Card prodotto in collezioni/ricerca/correlati: badge "In arrivo" / "Coming soon",
  // badge di fallback (esaurito/in saldo) e blocco quick-add (aggiungi al
  // carrello), cosi' che il pulsante d'acquisto non compaia già sulla card,
  // prima ancora di entrare nella pagina prodotto. Al posto del quick-add,
  // finché non è rilasciato, mostra un pulsante disabilitato "In arrivo"
  // (stesso trattamento visivo del pulsante "esaurito"), invece di lasciare
  // il vuoto.
  // Il badge di fallback, nascosto lato Liquid finché drop_gate_enabled, viene
  // mostrato non appena il drop-gate si sblocca: cosi' un prodotto già
  // rilasciato che va esaurito o in saldo torna a mostrare il badge corretto
  // invece di restarne privo per sempre (il metafield drop_date resta
  // impostato anche dopo il rilascio).
  function evaluateBadge(badgeEl) {
    var released = isReleased(badgeEl.getAttribute('data-drop-gate-date'));
    var unlocked = released || isUnlockedByCookie(badgeEl.getAttribute('data-drop-gate-token'));
    badgeEl.hidden = unlocked;

    var badgeContainer = badgeEl.closest('.card__badge') || badgeEl.parentElement;
    var companion = badgeContainer ? badgeContainer.querySelector('[data-drop-gate-companion]') : null;
    if (companion) companion.hidden = !unlocked;

    var cardContainer = badgeEl.closest('.card-wrapper');
    var buyBlock = cardContainer ? cardContainer.querySelector('[data-drop-gate-buy]') : null;
    if (buyBlock) buyBlock.hidden = !unlocked;

    var placeholder = cardContainer ? cardContainer.querySelector('[data-drop-gate-placeholder]') : null;
    if (placeholder) placeholder.hidden = unlocked;
  }

  function showNotifySuccess(formEl) {
    var fieldsEl = formEl.querySelector('[data-notify-fields]');
    var resultEl = formEl.querySelector('[data-notify-result]');
    if (fieldsEl) fieldsEl.hidden = true;
    if (resultEl) {
      resultEl.textContent = resultEl.getAttribute('data-success-text') || '';
      resultEl.hidden = false;
    }
  }

  function bindNotifyForm(formEl) {
    if (formEl.dataset.dropGateBound) return;
    formEl.dataset.dropGateBound = '1';

    var arrivoEl = formEl.closest('[data-drop-gate-arrivo]');
    var productId = arrivoEl ? arrivoEl.getAttribute('data-drop-gate-product') : null;

    // Il form si invia in modo nativo apposta (pulsante type="submit", nessun
    // preventDefault): è l'unico modo garantito compatibile con hCaptcha,
    // obbligatorio su tutti i form customer/contact di Shopify dal 2024 e
    // agganciato al vero evento submit della pagina (un invio via fetch
    // bypassa quell'aggancio e la richiesta viene rifiutata lato server,
    // senza alcun modo per JS di accorgersene — vedi commento in testa al
    // file). Dopo un invio riuscito la pagina ricarica e Shopify renderizza
    // il proprio messaggio di successo (form.posted_successfully?,
    // data-notify-native-success): lo rileviamo qui per ricordare
    // l'iscrizione e non far ricomparire il campo email.
    var nativeSuccessEl = formEl.querySelector('[data-notify-native-success]');
    if (nativeSuccessEl) {
      markProductNotified(productId);
      var fieldsEl = formEl.querySelector('[data-notify-fields]');
      if (fieldsEl) fieldsEl.hidden = true;
      return;
    }

    // Iscrizione già inviata per questo prodotto da questo browser: il campo
    // email non deve ricomparire, si mostra direttamente lo stato di
    // successo.
    if (isProductNotified(productId)) {
      showNotifySuccess(formEl);
    }
  }

  function scanAll() {
    var arrivoBlocks = document.querySelectorAll('[data-drop-gate-arrivo]');
    for (var i = 0; i < arrivoBlocks.length; i++) {
      evaluateGate(arrivoBlocks[i]);
    }

    var badges = document.querySelectorAll('[data-drop-gate-badge]');
    for (var j = 0; j < badges.length; j++) {
      evaluateBadge(badges[j]);
    }

    var notifyForms = document.querySelectorAll('.drop-gate__notify-form');
    for (var k = 0; k < notifyForms.length; k++) {
      bindNotifyForm(notifyForms[k]);
    }
  }

  // Il quick-add a comparsa sulle collezioni (scelta varianti) apre un
  // modale che recupera via fetch un frammento della pagina prodotto e lo
  // inserisce nel DOM dopo il caricamento iniziale (quick-add-modal, Dawn
  // stock, non in questo repo): quel frammento porta con sé i blocchi
  // drop-gate con l'attributo hidden di default, ma senza questo observer
  // nessuno script li rivaluta più. Un prodotto già rilasciato (drop_gate
  // resta "enabled" per sempre, si basa sulla sola presenza del metafield)
  // risulterebbe quindi bloccato per sempre dentro quel modale, pur essendo
  // acquistabile dalla pagina prodotto. Stesso rischio, in teoria, se il
  // cambio variante su pagina prodotto (Dawn stock) rigenera via fetch anche
  // il wrapper data-drop-gate-buy invece del solo contenuto interno: per
  // questo il selettore copre anche i blocchi acquisto/segnaposto, non solo
  // arrivo/badge/notify. Copre anche altri casi analoghi di contenuto
  // inserito dopo il load (es. ricerca predittiva).
  function observeMutations() {
    if (typeof MutationObserver === 'undefined' || !document.body) return;

    var selector =
      '[data-drop-gate-arrivo], [data-drop-gate-badge], [data-drop-gate-buy], [data-drop-gate-placeholder], .drop-gate__notify-form';
    var pending = false;

    var observer = new MutationObserver(function (mutations) {
      if (pending) return;
      var relevant = false;
      for (var i = 0; i < mutations.length && !relevant; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if ((node.matches && node.matches(selector)) || (node.querySelector && node.querySelector(selector))) {
            relevant = true;
            break;
          }
        }
      }
      if (!relevant) return;
      // Rimanda al termine dello stack di inserimenti DOM correnti, cosi'
      // una singola operazione che aggiunge più nodi (es. il fetch del
      // quick-add) produce un solo rescan invece di uno per nodo.
      pending = true;
      setTimeout(function () {
        pending = false;
        scanAll();
      }, 0);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Dopo l'invio del form "avvisami", Shopify rimanda a /products/...#notify-
  // form (l'id passato al form tag diventa un'ancora nell'URL di ritorno),
  // ma il risultato non è affidabile: a quel punto il blocco è ancora hidden
  // di default (lo toglie scanAll() un attimo dopo), e il successivo cambio
  // di altezza della pagina, combinato con lo "scroll anchoring" nativo del
  // browser (che sposta la pagina per compensare quando il contenuto sopra
  // la viewport cambia dimensione), porta in una posizione imprevedibile —
  // non necessariamente quella del blocco stesso. Invece di rincorrere una
  // posizione "corretta", si forza esplicitamente l'inizio pagina, cosi' un
  // invio riuscito riparte sempre da lì come un caricamento normale. Ripetuto
  // anche su window 'load' perché il browser può ritentare lo scroll
  // all'ancora dopo che le immagini hanno finito di caricare, oltre il primo
  // frame in cui l'abbiamo già corretto.
  function resetScrollForOwnHash() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var target = document.getElementById(hash.slice(1));
    if (!target || !target.closest('[data-drop-gate-arrivo]')) return;

    requestAnimationFrame(function () {
      window.scrollTo(0, 0);
    });
    window.addEventListener('load', function () {
      window.scrollTo(0, 0);
    });
  }

  function init() {
    applyEarlyAccessFromUrl();
    scanAll();
    resetScrollForOwnHash();
    observeMutations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
